/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Status_Athlete_DoingInputs */

const fr_week_session_status_athlete_doing = /** @type {(inputs: Week_Session_Status_Athlete_DoingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/**

* @param {Week_Session_Status_Athlete_DoingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_status_athlete_doing = /** @type {((inputs?: Week_Session_Status_Athlete_DoingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Status_Athlete_DoingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_status_athlete_doing(inputs)
});